import React from 'react';
import { map, size } from 'lodash';
import { useTranslation } from 'react-i18next';
import { Field, ErrorMessage } from 'formik';

import { GeneralQuestionnaire } from '../../shared/GeneralQuestionnaire';

const purposesTerminalFontSize = {
  fontSize: '1.5rem !important',
};

export default function PurposeOfVisitTerminalTemplate(props) {
  const { t } = useTranslation();
  const {
    // isPurposeOfVisitTypeTemplate,
    purposes,
    errors,
    handleChange,
    handleBlur,
    values,
    selectedVisitorType,
    touched,
    filteredQuestions,
    isSubmitting,
    onPrevClick,
    displayCompany,
    questionsEnabled,
    isEnableIfThenQuestionnaire,
  } = props;

  // const paginationWithouthPurposes = isPurposeOfVisitTypeTemplate && Boolean(size(purposes));

  return (
    <div className="text-white text-2xl">
      <div className={'questionPart'}>
        <h1 className="mt-4 text-3xl font-bold text-center">{t('Tell us about yourself')}</h1>
        <br />
        <div className="mb-4">
          <label className="block font-bold mb-2" htmlFor="name">
            {t('Name')}
          </label>
          <input
            className={`shadow appearance-none border-4 rounded w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
              errors.name && touched.name ? 'border-red-500' : ''
            }`}
            id="name"
            name="name"
            type="text"
            placeholder={t('Name')}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.name}
            autoComplete="off"
          />
          {/* <ErrorMessage className="text-gray-300 text-xl italic" component="p" name="name" /> */}
        </div>

        {/* {displayCompany && (
          <div className="mb-4">
            <label className="block font-bold mb-2" htmlFor="email">
              Email
            </label>
            <input
              className={`shadow appearance-none border-4 w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                errors.email && touched.email ? 'border-red-500' : ''
              }`}
              id="email"
              name="email"
              type="email"
              placeholder="Email address"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.email}
            />
            <ErrorMessage className="text-gray-300 text-xl italic" component="p" name="email" />
          </div>
        )} */}

        {displayCompany && (
          <div className="mb-4">
            <label className="block font-bold mb-2" htmlFor="company">
              {t('Company')}
            </label>
            <input
              className={`shadow appearance-none border-4 rounded w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                errors.company && touched.company ? 'border-red-500' : ''
              }`}
              id="company"
              name="company"
              type="text"
              placeholder={t('Company')}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.company}
              autoComplete="off"
            />
            <ErrorMessage className="text-gray-300 text-xl italic" component="p" name="company" />
          </div>
        )}
      </div>
      {Boolean(size(purposes)) && (
        <div className={'questionPart'}>
          <h1 className="mt-4 text-3xl font-bold text-center">{t('Purpose of your visit')}</h1>
          <br />
          <div className="mb-4">
            <div id="my-radio-group"></div>
            <div role="group" className="flex flex-col" aria-labelledby="my-radio-group">
              {map(purposes, (purpose) => (
                <label
                  className="flex justify-between items-center rounded py-2 px-4 my-1 hover:bg-blue-900"
                  style={{ ':focus': { color: 'red' } }}
                  tabIndex="0"
                  key={purpose.id}
                >
                  <span>{purpose.label}</span>
                  <Field className="w-6 h-6" type="radio" name="purposeOfVisit" id={purpose.id} value={purpose.label} />
                </label>
              ))}
              {/* <div>Picked: {values.purposeOfVisit}</div> */}
              {errors?.purposeOfVisit ? (
                <div className="text-xl italic text-center">{errors.purposeOfVisit}</div>
              ) : (
                <div className="text-xl italic text-center">
                  <br />
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {questionsEnabled && (
        <GeneralQuestionnaire
          props={props}
          selectedVisitorType={selectedVisitorType}
          onChange={handleChange}
          filteredQuestions={filteredQuestions}
          errors={errors}
          touched={touched}
          values={values}
          pagination={true}
          fontSize={purposesTerminalFontSize}
          isEnableIfThenQuestionnaire={isEnableIfThenQuestionnaire}
        />
      )}

      <div className={'questionPart'}>
        <img className="visitor-picture-preview" alt="" />
        <div className={'description'}>
          <div className={'descriptionBlock'}>
            <div className={'descriptionTitle'}>{t('I am')}</div>
            <div className={'descriptionValue'}>{values.entryType}</div>
          </div>
          <div className={'descriptionBlock'}>
            <div className={'descriptionTitle'}>{t('My name is')}</div>
            <div className={'descriptionValue'}>{values.name}</div>
          </div>
          {values.company && (
            <div className={'descriptionBlock'}>
              <div className={'descriptionTitle'}>{t('I am from')}</div>
              <div className={'descriptionValue'}>{values.company}</div>
            </div>
          )}
          {values.email && (
            <div className={'descriptionBlock'}>
              <div className={'descriptionTitle'}>Email</div>
              <div className={'descriptionValue'}>{values.email}</div>
            </div>
          )}
          {values.mobilePhoneNumber && (
            <div className={'descriptionBlock'}>
              <div className={'descriptionTitle'}>{t('Mobile')}</div>
              <div className={'descriptionValue'}>{values.mobilePhoneNumber}</div>
            </div>
          )}
          {values.purposeOfVisit && (
            <div className={'descriptionBlock'}>
              <div className={'descriptionTitle'}>{t('Purpose')}</div>
              <div className={'descriptionValue'}>{values.purposeOfVisit}</div>
            </div>
          )}
        </div>
        {values.nameOfHost && (
          <div className={'confirmQuestion'}>
            <div className={'confirmText'}>{t('Are you visiting')}</div>
            <div className={'confirmText'}>{values.nameOfHost}?</div>
          </div>
        )}
        <div className="flex items-center justify-between">
          <div onClick={onPrevClick} className={'buttonNo bg-blue-500 hover:bg-blue-700 font-bold focus:outline-none focus:shadow-outline'}>
            {t('NO')}
          </div>
          <button
            type="submit"
            value="Submit"
            className="buttonYes bg-blue-500 hover:bg-blue-700 font-bold focus:outline-none focus:shadow-outline"
            disabled={isSubmitting}
          >
            {isSubmitting ? t('Submitting') : t('YES')}
          </button>
        </div>
      </div>
    </div>
  );
}
